module.exports = __webpack_public_path__ + "img/video-player.764d48c8.png";